import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";

var CheckboxControl = function CheckboxControl(_ref) {
  var checked = _ref.checked,
      defaultChecked = _ref.defaultChecked,
      disabled = _ref.disabled,
      id = _ref.id,
      labelText = _ref.labelText,
      name = _ref.name,
      onChange = _ref.onChange,
      required = _ref.required,
      value = _ref.value,
      _ref$withOptionalLabe = _ref.withOptionalLabel,
      withOptionalLabel = _ref$withOptionalLabe === void 0 ? true : _ref$withOptionalLabe,
      ariaLive = _ref.ariaLive,
      ariaControls = _ref.ariaControls,
      ariaRelevant = _ref.ariaRelevant,
      ariaDescribedby = _ref.ariaDescribedby,
      _ref$optionalText = _ref.optionalText,
      optionalText = _ref$optionalText === void 0 ? "(Optional)" : _ref$optionalText;
  var getClassName = getClassNameFactory(CheckboxControl.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("label", {
    "aria-required": required,
    className: getClassName({
      descendantName: "label"
    }),
    htmlFor: id
  }, /*#__PURE__*/React.createElement("input", {
    className: getClassName({
      descendantName: "input"
    }),
    checked: checked,
    defaultChecked: defaultChecked,
    disabled: disabled,
    id: id,
    name: name,
    onChange: onChange,
    type: "checkbox",
    value: value,
    "aria-invalid": "false",
    "aria-live": ariaLive,
    "aria-controls": ariaControls,
    "aria-relevant": ariaRelevant,
    "aria-describedby": ariaDescribedby
  }), /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "labelText"
    })
  }, labelText, !required && withOptionalLabel && /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "optional"
    })
  }, optionalText))));
};

CheckboxControl.displayName = "Form.CheckboxControl";
CheckboxControl.propTypes = {
  /**
   * Check the <input>. Will switch into controlled mode.
   */
  checked: PropTypes.bool,

  /**
   * Set the initial checked state for the <input>.
   */
  defaultChecked: PropTypes.bool,

  /**
   * Disable the <input>
   */
  disabled: PropTypes.bool,

  /**
   * Id attribute for <input> (and <label>'s `for` attribute)
   */
  id: PropTypes.string.isRequired,

  /**
   * Text for <label>
   */
  labelText: PropTypes.string.isRequired,

  /**
   * Name attribute for <input>, required for serialisation
   */
  name: PropTypes.string,

  /**
   * Add an onChange callback to the <input>.
   */
  onChange: PropTypes.func,

  /**
   * Set <input> to be required
   */
  required: PropTypes.bool,

  /**
   * Initialize <input> with a value
   */
  value: PropTypes.string,

  /**
   * check if should show optional label
   */
  withOptionalLabel: PropTypes.bool,
  ariaLive: PropTypes.string,
  ariaControls: PropTypes.string,
  ariaRelevant: PropTypes.string,
  ariaDescribedby: PropTypes.string,

  /**
   * render custom optionalText
   */
  optionalText: PropTypes.node
};
export default CheckboxControl;